import React from 'react';
import { useTranslation } from 'react-i18next';

import ProjectsAndIncentivesPageLayout from '../../components/ProjectsAndIncentivesPageLayout';
import SEO from '../../components/SEO';
import Lisboa2020_1a from '../../assets/images/logos/Lisboa2020_RGB_1a.png';
import Lisboa2020_1b from '../../assets/images/logos/Lisboa2020_RGB_1b.png';
import Lisboa2020_1c from '../../assets/images/logos/Lisboa2020_RGB_1c.png';

import * as styles from './projects.module.scss';

const projects = (): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <ProjectsAndIncentivesPageLayout currentSlug="projects">
      <SEO
        title={t('projects_and_incentives.projects_page.title', 'Projects')}
        urlPath={'/projects-and-incentives/projects'}
      />
      <h1>PROJETOS ASCENZA AGRO</h1>
      <div className={styles.logos}>
        <div className={styles.logoContainer}>
          <img className={styles.logo} src={Lisboa2020_1a} alt="Lisboa 2020 Logo" />
        </div>
        <div className={styles.logoContainer}>
          <img className={styles.logo} src={Lisboa2020_1b} alt="Portugal 2020 Logo" />
        </div>
        <div className={styles.logoContainer}>
          <img className={styles.logo} src={Lisboa2020_1c} alt="FEDER Logo" />
        </div>
      </div>
      <p>
        <strong>Designação do Projeto:</strong> Sea4CS – Desenvolvimento de microencapsulados com
        biopolímeros de origem marinha
      </p>
      <p>
        <strong>Código do projeto:</strong> LISBOA-01-0247-FEDER-045208
      </p>
      <p>
        <strong>Objetivo principal:</strong> OT1 – Reforçar a investigação, o desenvolvimento
        tecnológico e a inovação
      </p>
      <p>
        <strong>Região de intervenção:</strong> NUTS II Lisboa
      </p>
      <p>
        <strong>Entidade beneficiária:</strong> ASCENZA Agro, S.A.
      </p>
      <p>
        <strong>Data de aprovação:</strong> 17-12-2019
      </p>
      <p>
        <strong>Data de início:</strong> 01-03-2020
      </p>
      <p>
        <strong>Data de conclusão:</strong> 01-03-2022
      </p>
      <p>
        <strong>Custo total elegível:</strong> 1.340.241,85 EUR
      </p>
      <p>
        <strong>Apoio financeiro da União Europeia:</strong> FEDER – 646.289,80 EUR
      </p>
      <p>
        <strong>Âmbito:</strong> O projeto visa a criação de uma nova geração de produtos
        fitofarmacêuticos microencapsulados com biopolímeros de origem marinha, tendo em vista a
        substituição do suso dos microplásticos, garantindo impactos positivos no ambiente e na
        saúde humana e, bem assim, promovendo uma agricultura sustentável.
      </p>
      <hr></hr>
      <p>
        <strong>Designação do Projeto:</strong> PROTCROP4HEALTH – Novos co formulantes verdes para o
        desenvolvimento de produtos fitofarmacêuticos promotores de uma agricultura sustentável e da
        melhoria da saúde humana
      </p>
      <p>
        <strong>Código do projeto:</strong> LISBOA-01-0247-FEDER-024016
      </p>
      <p>
        <strong>Objetivo principal:</strong> OT1 – Reforçar a investigação, o desenvolvimento
        tecnológico e a inovação
      </p>
      <p>
        <strong>Região de intervenção:</strong> NUTS II Lisboa
      </p>
      <p>
        <strong>Entidade beneficiária:</strong> ASCENZA Agro, S.A.
      </p>
      <p>
        <strong>Data de aprovação:</strong> 12-09-2017
      </p>
      <p>
        <strong>Data de início:</strong> 01-11-2017
      </p>
      <p>
        <strong>Data de conclusão:</strong> 31-10-2019
      </p>
      <p>
        <strong>Custo total elegível:</strong> 1.141.104,04 EUR
      </p>
      <p>
        <strong>Apoio financeiro da União Europeia:</strong> FEDER – 456.441,62 EUR
      </p>
      <p>
        <strong>Âmbito:</strong> O projeto visa a criação de uma nova geração de produtos
        fitofarmacêuticos em linha com o conceito de química verde, associado à redução do impacto
        para a saúde humana e para o ambiente e à promoção de uma agricultura sustentável. Para além
        das descobertas científicas que se perspetivam que o projeto venha a proporcionar, é
        expectável que dê origem a novas formulações experimentais de herbicidas e fungicidas com
        incorporação de novos co formulantes verdes.
      </p>
      <hr></hr>
      <p>
        <strong>Designação do Projeto:</strong> HYBRID XXI – Desenvolvimento de novas formulações de
        produtos fitofarmacêuticos com micro-organismos ou compostos de origem natural (algas)
        associado a substâncias ativas químicas
      </p>
      <p>
        <strong>Código do projeto:</strong> LISBOA-01-0247-FEDER-011130
      </p>
      <p>
        <strong>Objetivo principal:</strong> OT1 – Reforçar a investigação, o desenvolvimento
        tecnológico e a inovação
      </p>
      <p>
        <strong>Região de intervenção:</strong> NUTS II Lisboa
      </p>
      <p>
        <strong>Entidade beneficiária:</strong> Sapec – Agro, S.A.
      </p>
      <p>
        <strong>Data de aprovação:</strong> 13-05-2016
      </p>
      <p>
        <strong>Data de início:</strong> 01-09-2015
      </p>
      <p>
        <strong>Data de conclusão:</strong> 31-10-2017
      </p>
      <p>
        <strong>Custo total elegível:</strong> 1.164.631,92 EUR
      </p>
      <p>
        <strong>Apoio financeiro da União Europeia:</strong> FEDER – 465.852,77 EUR
      </p>
      <p>
        <strong>Âmbito:</strong> Desenvolvimento de formulações de produtos fitofarmacêuticos que
        associem uma molécula química (com ação sobre agentes patogénicos, em particular) a um
        produto de origem natural (micro-organismos, como bactérias ou fungos, extratos de origem
        vegetal incluindo as algas) que poderão vir a contribuir para garantir uma elevada eficácia
        nos resultados, reduzindo os níveis de resíduos de substâncias fitofarmacêuticas químicas,
        com uma consequente diminuição dos eventuais riscos para a saúde tanto do consumidor final,
        como do próprio aplicador.
      </p>
    </ProjectsAndIncentivesPageLayout>
  );
};

export default projects;
